// Module
var code = `<template> <div class="page-onboarding-custom-content"> <div class="onboarding-custom-content row justify-content-center align-items-middle"> <h1 style="padding:80px 0">This form is now Cancelled!</h1> </div> </div> </template>`;
// Exports
module.exports = code;